var FetchAdapter = /** @class */ (function () {
    function FetchAdapter() {
    }
    FetchAdapter.prototype.post = function (url, data, options) {
        return new Promise(function (resolve, reject) {
            return fetch(url, {
                method: 'post',
                body: JSON.stringify(data),
                headers: options.headers,
            })
                .then(function (response) {
                if (response.status !== 200) {
                    return reject("got status code " + response.status);
                }
                return response.json();
            })
                .then(function (response) {
                if (response.errors && response.errors.length) {
                    reject(response.errors);
                }
                else {
                    resolve(response);
                }
            })
                .catch(function (e) { return reject(e); });
        });
    };
    FetchAdapter.prototype.get = function (url, options) {
        return new Promise(function (resolve, reject) {
            return fetch(url, {
                method: 'get',
                headers: options.headers,
            }).then(function (response) {
                if (response.status !== 200) {
                    return reject("got status code " + response.status);
                }
                return resolve(response.json());
            });
        });
    };
    FetchAdapter.prototype.delete = function (url, options) {
        return new Promise(function (resolve, reject) {
            return fetch(url, {
                method: 'delete',
                headers: options.headers,
            }).then(function (response) {
                if (response.status !== 200) {
                    return reject("got status code " + response.status);
                }
                return resolve(response.json());
            });
        });
    };
    FetchAdapter.prototype.patch = function (url, data, options) {
        return new Promise(function (resolve, reject) {
            return fetch(url, {
                method: 'path',
                body: JSON.stringify(data),
                headers: options.headers,
            }).then(function (response) {
                if (response.status !== 200) {
                    return reject("got status code " + response.status);
                }
                return resolve(response.json());
            });
        });
    };
    return FetchAdapter;
}());
export { FetchAdapter };
var InstanceManager = /** @class */ (function () {
    function InstanceManager(instance) {
        this.instance = instance;
    }
    InstanceManager.prototype.getInstance = function () {
        return this.instance;
    };
    return InstanceManager;
}());
export { InstanceManager };
//# sourceMappingURL=fetch-wrapper.js.map